import router from '../router'
// import store from '../store'
// import wechatAuth from '../plugins/wechatAuth' // 微信登录插件

// function urlDelP (url, name) {
//   var urlArr = url.split('?')
//   if (urlArr.length > 1 && urlArr[1].indexOf(name) > -1) {
//     var query = urlArr[1]
//     var obj = {}
//     var arr = query.split('&')
//     for (var i = 0; i < arr.length; i++) {
//       arr[i] = arr[i].split('=')
//       obj[arr[i][0]] = arr[i][1]
//     }
//     delete obj[name]
//     var urlte = urlArr[0] + '?' + JSON.stringify(obj).replace(/["{}]/g, '').replace(/:/g, '=').replace(/,/g, '&')
//     return urlte
//   } else {
//     return url
//   }
// }
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
  // if (to.meta.keepAlive) {
  //   const iccid = store.getters.iccid
  //   if (!iccid || !to.params.iccid || iccid.toString() !== to.params.iccid.toString()) {
  //     if (to.meta.path) {
  //       router.push(to.meta.path)
  //     } else {
  //       router.push('/')
  //     }
  //   }
  // }
  // if (to.query.id !== from.query.id) {
  //   this.id = to.query.id
  //   this.init() // 重新加载数据
  // }
  // const url = window.location.href
  // const appid = 'wxd4c16e8d00b8550e'
  // /* 授权 */
  // if (to.meta.auth) {
  //   const loginStatus = Number(store.getters.loginStatus)
  //   console.log('loginStatus=' + loginStatus)
  //   // 页面标题
  //   if (loginStatus === 0) {
  //     // 微信未授权登录跳转到授权登录页面
  //     // 解决重复登录url添加重复的code与state问题
  //     // const code = getQueryVariable('code')
  //     // const state = getQueryVariable('state')
  //
  //     let loginUrl = urlDelP(url, 'code')
  //     loginUrl = urlDelP(loginUrl, 'state')
  //     // 设置微信授权回调地址
  //     wechatAuth.scope = 'snsapi_base'
  //     wechatAuth.redirectUri = loginUrl
  //
  //     wechatAuth.appid = appid
  //     // 无论拒绝还是授权都设置成1
  //     store.dispatch('user/setLoginStatus', 1)
  //     // 跳转到微信授权页面
  //     if (wechatAuth.authUrl) {
  //       window.location.href = wechatAuth.authUrl
  //     }
  //   } else if (loginStatus === 1) {
  //     // 用户已授权，获取code
  //     try {
  //       // 通过回调链接设置code status
  //       wechatAuth.returnFromWechat(window.location.href)
  //     } catch (err) {
  //       // 失败，设置状态未登录，刷新页面
  //       store.dispatch('user/setLoginStatus', 0)
  //       alert('授权失败4000！')
  //       // location.reload()
  //     }
  //     // 同意授权 to.fullPath 携带code参数，拒绝授权没有code参数
  //     const code = wechatAuth.code
  //     if (code) {
  //       // 拿到code 访问服务端的登录接口
  //       store.dispatch('user/loginWechatAuth', {code, appid}).then(res => {
  //         // 成功设置已登录状态
  //         store.dispatch('user/setLoginStatus', 2)
  //         store.commit('user/SET_LOGIN_STATUS', 2)
  //         // 记录openid
  //         store.dispatch('user/setOpenid', res.data.data.openid)
  //         store.commit('user/SET_OPENID', res.data.data.openid)
  //         // 记录appid
  //         store.dispatch('user/setAppid', appid)
  //         store.commit('user/SET_APPID', appid)
  //         next()
  //       }).catch(() => {
  //         // 失败，设置状态未登录，刷新页面
  //         store.dispatch('user/setLoginStatus', 0)
  //         alert('授权失败4001！')
  //       })
  //     } else {
  //       store.dispatch('user/setLoginStatus', 0)
  //       alert('授权失败4002！')
  //     }
  //   } else {
  //     // 已登录直接进入
  //     next()
  //   }
  // } else {
  //   next()
  // }
})



// WEBPACK FOOTER //
// ./src/card/init.js